/**
 * Extrai o status atual `done` das respostas dos endpoints de "concluir" do
 * cronograma personalizado. Como cada tipo de conteúdo responde num formato
 * diferente (e o discursivo responde apenas `true`), procuramos o primeiro
 * booleano `done`/`concluido` em qualquer nível da resposta.
 *
 * Fallback para `true` quando a resposta não traz o status (mantém o
 * comportamento de "marcar como concluído").
 */
function findDoneFlag(value: unknown): boolean | undefined {
  if (value == null || typeof value !== 'object') return undefined;

  const obj = value as Record<string, unknown>;

  if (typeof obj.done === 'boolean') return obj.done;
  if (typeof obj.concluido === 'boolean') return obj.concluido;

  for (const key of Object.keys(obj)) {
    const found = findDoneFlag(obj[key]);
    if (found !== undefined) return found;
  }

  return undefined;
}

export function getDoneFromPAResponse(response: unknown): boolean {
  if (typeof response === 'boolean') return response;

  return findDoneFlag(response) ?? true;
}
